module.exports = __webpack_public_path__ + "img/print-logo.8af0151d.png";